import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getTermsAndConditions = (data, token) => {
  let url = `${baseUrl}/pmtpartner-terms`;
  return axios.patch(url, data, {
    headers: {
      authorization: token,
    },
  });
};
export const getTermsAndConditionsDownload = (token) => {
  let url = `${baseUrl}/downloadtermsfile`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
export const postUploadDocument = (myFile, id, token) => {
  return axios.post(`${baseUrl}/uploadfilebypartner/${id}`, myFile, {
    headers: {
      authorization: token,
    },
  });
};
